import {
  previous_month_average_cluster,
  previous_month_average_area,
  previous_month_average_branch,
} from "../../services/reports/previous_month_average";
import { actionTypes } from "../action_types";

const defaultPayload = [];

const createPreviousMonthAverageAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    return fetchFunction(data)
      .then((resp) => {
        if (resp.problem === null) {
          dispatch({
            type: actionType,
            payload: resp.data !== null ? resp.data : defaultPayload,
          });
        }
        return Promise.resolve(resp);
      })
      .catch((err) => {
        dispatch({
          type: actionType,
          payload: defaultPayload,
        });
        return Promise.resolve(err);
      });
  };

export const SetPreviousMonthAverageSetScopeDate = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_SET_SCOPE_DATE,
    payload: data,
  });
};

export const GetPreviousMonthAverageCluster = createPreviousMonthAverageAction(
  previous_month_average_cluster,
  actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_GET_CLUSTER
);

export const GetPreviousMonthAverageArea = createPreviousMonthAverageAction(
  previous_month_average_area,
  actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_GET_AREA
);

export const GetPreviousMonthAverageBranch = createPreviousMonthAverageAction(
  previous_month_average_branch,
  actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_GET_BRANCH
);
